<div class="flex-col gap-16 h100">
  <vl-widget-title [text]="'dashboard_ui.productivite' | trans" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
  </vl-widget-title>

  @if (metadata()?.loading) {
    <div class="h100 overflow-hidden">
      <ngx-skeleton-loader count="20" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else {
    <div class="grow list-area">
      <div class="h100 overflow-scroll flex-col gap-4 fade-in">
        @for (ligne of dataDisplay(); track ligne.ligneDenomination) {
          <div class="flex-col">
            <div class="flex-row gap-12">
              <span class="body-2 grow flex-row align-center">{{ligne.ligneDenomination}}</span>
              <span class="body-2 flex-row align-center {{+ligne.score_poste > 2 ? 'widget-'+widget()?.color : 'on-warning'}}">{{ligne.score}}%</span>
              <div class="flex-row evaluation">
                @if (+ligne.score_poste <= 2) {
                  <mat-icon class="on-warning">warning</mat-icon>
                } @else {
                  @for (i of 5 | range; track $index) {
                    @if (i+1 <= +ligne.score_poste) {
                      <mat-icon class="on-warning2">star</mat-icon>
                    } @else {
                      <mat-icon class="on-disabled">star_border</mat-icon>
                    }
                  }

                }
              </div>
            </div>
            @if(!$last) {
              <div class="divider-on-disabled mt-4"></div>
            }
          </div>
        } @empty {
          <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
        }
      </div>

      @if (totalCount() > 0) {
        <vl-chips class="see-all-chip"
                  state="active"
                  size="small"
                  iconRight="open_in_new"
                  (action)="onSeeAll()"
                  matTooltip="Productivité par ligne avec recherche, tri et export Excel">
          {{ 'button.see_all' | trans }}
        </vl-chips>
      }
    </div>
  }

</div>
